export default function existingTickets(event) {
  const {
    maximum_tickets: tickets, data: { tickets_sold: sellingTickets },
  } = event;

  return tickets - sellingTickets;
}
